import React, { useEffect, useState } from "react";
import API from "../lib/TimeEditAPI";
import ArrayInput from "./ArrayInput";
import _ from "underscore";

const DEFAULT_SIZE = 5;

type TTypeInputProps = {
    defaultValue: number[];
    onUpdate: (val: any) => void;
    limit?: number;
    defaultSize?: number;
};

const TypeInput = (props: TTypeInputProps) => {
    const [types, setTypes] = useState<any[]>([]);

    useEffect(() => {
        API.updateMcFluffy(null, (res) => {
            const reservationTypes = res.parameters[1].types;
            API.findTypes((found) => {
                const filteredTypes = found.filter((type) =>
                    _.find(reservationTypes, (reservationType) => type.id === reservationType.id)
                );
                setTypes(filteredTypes);
            });
        });
    }, []);

    const options = types.map((type) => ({
        value: type.id,
        label: type.name,
        selected: _.contains(props.defaultValue, type.id),
    }));
    return (
        <ArrayInput
            defaultValue={options}
            disabled={types.length === 0}
            onUpdate={props.onUpdate}
            limit={props.limit || 0}
            defaultSize={props.defaultSize || DEFAULT_SIZE}
        />
    );
};

export default TypeInput;
